import { createAsyncThunk } from "@reduxjs/toolkit";
import type { LicensePriceDTO } from "types";
import { apiGet } from "utilities/api";
import { LICENSE_PRICES_FOLDER_PATH, SCOPES } from "utilities/constants/constants";

export const fetchLicensePrices = createAsyncThunk(
	"licenses/fetchLicensePrices",
	apiGet<LicensePriceDTO>(
		(authConfig) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_CUSTOMER_DATA(LICENSE_PRICES_FOLDER_PATH),
		[SCOPES.DATA_LAKE_READ],
	),
);
